(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aio-hero"] && !Shopify.designMode) return;
  try {
    
  class ScrollButton extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', () => {
        const next = this.closest('.shopify-section')?.nextElementSibling;
        next?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
  if (!customElements.get('scroll-button')) {
    customElements.define('scroll-button', ScrollButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-main-cart"]) return;
  try {
    
  class CartUpsellAdd extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.isLoading = false;
      this.defaultLabel = 'Add to basket';
    }

    connectedCallback() {
      this.link = this.querySelector('[data-upsell-add-to-basket]');
      if (!this.link) return;

      this.defaultLabel = this.link.textContent.trim() || this.defaultLabel;
      this.link.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.link) {
        this.link.removeEventListener('click', this.handleClick);
      }
    }

    async handleClick(event) {
      if (!this.link || this.isLoading) return;

      event.preventDefault();

      const variantId = parseInt(this.dataset.variantId, 10);
      if (!variantId) {
        window.location.href = this.link.href;
        return;
      }

      this.setLoadingState(true);

      try {
        const sectionId = this.dataset.sectionId;
        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
            sections: sectionId ? [sectionId] : undefined,
            sections_url: '/cart',
          }),
        });

        if (!addResponse.ok) {
          throw new Error('Unable to add upsell product to cart');
        }

        const addData = await addResponse.json();
        const sectionMarkup =
          sectionId && addData.sections ? addData.sections[sectionId] || Object.values(addData.sections)[0] : null;

        if (sectionMarkup) {
          this.swapCartMarkup(sectionMarkup);
        } else {
          await this.reloadCartSection();
        }

        if (window.AM && typeof window.AM.updateHeaderCartItems === 'function') {
          window.AM.updateHeaderCartItems();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.setLoadingState(false);
      }
    }

    setLoadingState(isLoading) {
      this.isLoading = isLoading;

      if (!this.link) return;

      this.link.setAttribute('aria-busy', String(isLoading));
      this.link.textContent = isLoading ? 'Adding...' : this.defaultLabel;
    }

    async reloadCartSection() {
      const response = await fetch(`${window.Shopify.routes.root}cart`, {
        headers: {
          Accept: 'text/html',
        },
      });

      if (!response.ok) {
        throw new Error('Unable to reload cart section');
      }

      const pageMarkup = await response.text();
      this.swapCartMarkup(pageMarkup);
    }

    swapCartMarkup(markup) {
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const currentCart = this.closest('.cart');
      const nextCart = parsed.querySelector('.cart');

      if (!currentCart || !nextCart) {
        throw new Error('Unable to locate cart markup to swap');
      }

      currentCart.outerHTML = nextCart.outerHTML;
    }
  }

  if (!customElements.get('cart-upsell-add')) {
    customElements.define('cart-upsell-add', CartUpsellAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-main-collections-finishes"] && !Shopify.designMode) return;
  try {
    
  class OurFinishes extends HTMLElement {
    connectedCallback() {
      const filters = this.querySelector('.our-finishes__filters');
      const finishes = this.querySelectorAll('.our-finishes__finishes');
      if (finishes.length === 0) return;

      filters.querySelector('ul').replaceChildren(
        ...Array.from(finishes, (finish) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.filter = finish.dataset.filter;
          button.textContent = finish.dataset.filterTitle;
          item.append(button);
          return item;
        })
      );

      filters.addEventListener('click', (event) => {
        const filter = event.target.closest('button[data-filter]')?.dataset.filter;
        if (!filter) return;

        this.querySelector(`.our-finishes__finishes[data-filter="${filter}"]`)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });

      filters.hidden = false;
    }
  }

  if (!customElements.get('our-finishes')) {
    customElements.define('our-finishes', OurFinishes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-our-collections"] && !Shopify.designMode) return;
  try {
    
  class OurCollectionsCarousel extends HTMLElement {
    connectedCallback() {
      this.#initSwiper();
    }

    #initSwiper() {
      const swiper = this.querySelector('.swiper');
      if (!swiper) {
        return;
      }

      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) {
        return;
      }

      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');

      if (typeof Swiper !== 'undefined') {
        new Swiper(swiper, {
          loop: slides.length > 4,
          draggable: true,
          spaceBetween: 24,
          navigation: {
            nextEl,
            prevEl,
          },
          breakpoints: {
            0: {
              slidesPerView: 2.5,
            },
            768: {
              slidesPerView: 3.5,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        });
      } else {
        requestAnimationFrame(this.#initSwiper.bind(this));
      }
    }
  }

  if (!customElements.get('our-collections-carousel')) {
    customElements.define('our-collections-carousel', OurCollectionsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.itemsWrapper = this.querySelector('.related-products__list');
      this.products = this.#getProducts();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.#renderProducts(this.products).then((hasProducts) => {
        if (hasProducts) {
          this.#initSwiper();
        }
      });
    }

    #initSwiper() {
      const swiper = this.querySelector('.swiper');
      const slides = this.querySelectorAll('.swiper-slide');
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');

      if (!slides.length) {
        return;
      }

      if (typeof Swiper !== 'undefined') {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }

        // Navigation buttons can keep lock/disabled classes after re-init on SPA transitions.
        [nextEl, prevEl].forEach((button) => {
          if (!button) {
            return;
          }

          button.classList.remove('swiper-button-lock', 'swiper-button-disabled');
          button.removeAttribute('aria-disabled');
        });

        this.swiperInstance = new Swiper(swiper, {
          loop: slides.length > 4,
          draggable: true,
          spaceBetween: 24,
          watchOverflow: false,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl,
            prevEl,
          },
          breakpoints: {
            0: {
              slidesPerView: 2.5,
            },
            768: {
              slidesPerView: 3.5,
            },
            1024: {
              slidesPerView: 4,
            },
          },
        });

        this.swiperInstance.update();
        this.swiperInstance.navigation.update();
      } else {
        requestAnimationFrame(this.#initSwiper.bind(this));
      }
    }

    #getProducts() {
      const productData = this.querySelector('.related-products__data');

      if (!productData) {
        return [];
      }

      try {
        return JSON.parse(productData.textContent);
      } catch (error) {
        console.error('Error parsing related products data:', error);
        return [];
      }
    }

    #fetchFirstInsitu(product) {
      return fetch(product.url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const firstInsitu = doc.querySelector('script[type="application/json"]#insitu-data');
          if (!firstInsitu) {
            return null;
          }
          return JSON.parse(firstInsitu.textContent);
        });
    }

    #renderProducts(products) {
      if (!products || products.length === 0) {
        this.style.display = 'none';
        return Promise.resolve(false);
      }

      let priceConfig = {};
      if (window.Shopify.shop.includes('usa')) {
        priceConfig = {
          tax: 1,
          countryCode: 'US',
          currency: 'USD',
        };
      } else {
        priceConfig = {
          tax: 1.2,
          countryCode: 'GB',
          currency: 'GBP',
        };
      }

      return Promise.all(
        products.map(async (product) => {
          const firstInsitu = await this.#fetchFirstInsitu(product);

          let image = '';
          if (firstInsitu?.firstInsitu) {
            image = `https://${window.Shopify.cdnHost}/shop/${firstInsitu.firstInsitu}?width=300&height=300`;
          } else {
            image = product.featured_image ? `${product.featured_image}?width=300&height=300` : '';
          }

          return `
              <a href="${product.url}" class="related-products__item swiper-slide" role="listitem">
                <div class="related-products__image"><img src="${image}" alt="${
            product.title
          }" width="300" height="300"/></div>
                <div class="related-products__meta">
                  <div class="related-products__meta-top">
                    <h4 class="copy-sm-medium">${product.title}</h4>
                    ${
                      product.price > 0
                        ? `<h5 class="copy-sm-light price">From ${AM.formatCurrency(
                            product.price,
                            priceConfig.tax,
                            priceConfig.countryCode,
                            priceConfig.currency
                          )}</h5>`
                        : ''
                    }
                  </div>
                </div>
              </a>
            `;
        })
      ).then((htmlArray) => {
        this.itemsWrapper.innerHTML = htmlArray.join('');
        return true;
      });
    }
  }

  customElements.define('related-products', RelatedProducts);

  } catch(e) { console.error(e); }
})();
})();
